import { render, staticRenderFns } from "./ValidationCodeModal.vue?vue&type=template&id=1aee7b3c&scoped=true&"
import script from "./ValidationCodeModal.vue?vue&type=script&lang=js&"
export * from "./ValidationCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee7b3c",
  null
  
)

export default component.exports